import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { metaOverrideSet } from 'Views/Page/Content/Templates/CapitalizeRolloverWebviewStepTemplate/metaOverride';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Layout from './Layout';

const Content = ({ resource }) => {
  const { setPageContentCollection } = usePageContentContext();

  return (
    <Stack direction={'column'} alignItems={'center'}>
      <Stack direction={'column'} alignItems={'center'} spacing={4} maxWidth={684}>
        <MetaResourceRenderer
          resource={resource}
          layout={Layout}
          metaOverrideSet={metaOverrideSet}
          onSubmit={setPageContentCollection}
        />
      </Stack>
    </Stack>
  );
};

Content.defaultProps = {
};

Content.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default Content;
